export class TenantForm {
    public company: string = "";
    public configurationName: string = "";
    public logoUrl: string = "";
    public reporterUrl: string = "";
    public name: string = "";
    public created_at: string = "";
    public has_url: boolean = true;
}